import { render, staticRenderFns } from "./RtpManagement.vue?vue&type=template&id=dfb67b48&scoped=true&"
import script from "./RtpManagement.vue?vue&type=script&lang=ts&"
export * from "./RtpManagement.vue?vue&type=script&lang=ts&"
import style0 from "./RtpManagement.vue?vue&type=style&index=0&id=dfb67b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb67b48",
  null
  
)

export default component.exports